
const chatinternal = (state = [], action) => {
    switch (action.type) {
      case 'ADD_CHAT':
      return {
          type: "ADD_CHAT",
          iduserout: action.iduserout,
          id: action.id,
          agent: action.agent,
          active: action.active,
          voz: action.opencall,
          dateinit: action.dateinit,
          line:action.line,
          ramal: action.ramal
        }
      case 'EDIT_VOZ_INTERNAL':
          return { ...state,
                voz: action.opencall,
                line:action.line, 
                active: action.active} 
      case 'EDIT_VOZ_INTERNAL_LINE':
        return(
          (parseInt(action.line) === parseInt(state.line)) || (state.line!== undefined) || (state.line!== "undefined") ?
            { ...state,  line:0, voz:false } :
            state
        )
      case 'REMOVE_CHATUNIQUE':
          return [];
      case 'END_CALL':
        return { ...state,voz: false} 
      case 'END_CALL_LINE':
        return(
          (parseInt(action.line) === parseInt(state.line)) || (state.line!== undefined) || (state.line!== "undefined") ?
            { ...state,  line:0, voz:false } :
            state
        )
      default:
          return state
    }
  }
  
  export default chatinternal